import { motion, type HTMLMotionProps } from "framer-motion";
import type { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "hover" | "interactive";
}

export function Card({
  className = "",
  variant = "default",
  children,
  ...props
}: CardProps) {
  const baseStyles = "rounded-xl border border-white/[0.08] backdrop-blur-md";
  
  const variants = {
    default: "bg-white/[0.02]",
    hover: "bg-white/[0.02] transition-all duration-300 hover:border-white/[0.12] hover:bg-white/[0.04] hover:shadow-2xl hover:shadow-black/20",
    interactive: "bg-white/[0.02] cursor-pointer transition-all duration-300 hover:border-white/[0.12] hover:bg-white/[0.04] hover:shadow-2xl hover:shadow-black/20 hover:-translate-y-1",
  };

  if (variant === "interactive") {
    return (
      <motion.div
        className={`${baseStyles} ${variants[variant]} ${className}`}
        whileHover={{ y: -4 }}
        transition={{ duration: 0.2 }}
        {...(props as HTMLMotionProps<"div">)}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <div
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
} 